// services/reports.service.ts
import { apiService } from "./../../app.service";

export const reportApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchReports: builder.query({
      query: (locationId) => ({
        url: `/report${locationId ? `?locationId=${locationId}` : ''}`,
      }),
      providesTags: ["reports"],
    }),
    
    fetchReportsByPeriod: builder.mutation({
      query: ({ params, locationId }) => ({
        url: `/report${locationId ? `?locationId=${locationId}` : ''}`,
        method: "POST",
        params,
      }),
      invalidatesTags: ["reports"],
    }),
    
    deleteReport: builder.mutation({
      query: ({ logId, locationId }) => ({
        url: `/report/${logId}${locationId ? `?locationId=${locationId}` : ''}`,
        method: "DELETE",
      }),
      invalidatesTags: ["reports"],
    }),
  }),
});

export const {
  useFetchReportsByPeriodMutation,
  useFetchReportsQuery,
  useDeleteReportMutation,
} = reportApi;